module.exports = __webpack_public_path__ + "img/echartbg.336e31bd.png";